import React, { useState, useEffect } from "react";
import { getCurrentDate, getFirstDayOfMonth } from "@thequantumhub/iam-package";
import { Grid } from "@material-ui/core";
import { Button, Typography } from "@mui/material";
import { getUniqueUserIds } from "@thequantumhub/iam-package";

import { getDiningRecords } from "../../../service/endpoint-manager";
import { getUserNames } from "../../../service/endpoint-manager";

import DiningDataFilters from "./DiningDataFilters";
import DiningForm from "./DiningForm";
import DiningAuditSummary from "./DiningAuditSummary";

const DiningDashboard = () => {
  const [isDashboard, setIsDashboard] = useState(true);

  const [diningRecords, setDiningRecords] = useState([]);
  const [filteredDiningRecords, setFilteredDiningRecords] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [userNames, setUserNames] = useState([]);

  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState("all");
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("all");
  const [selectedUser, setSelectedUser] = useState("All");
  const [recordStatus, setRecordStatus] = useState("Active");
  const [startDate, setStartDate] = useState(getFirstDayOfMonth());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const resetFilters = () => {
    setUnits([]);
    setSelectedUnit("all");
    setSelectedUser("All");
    setStartDate("");
    setEndDate("");
  };

  const loadData = async () => {
    try {
      const response = await getDiningRecords({
        deleted: recordStatus === "Deleted",
        from: startDate,
        to: endDate,
      });
      let records = response.data.body;
      const userList = getUniqueUserIds(records, "auditedBy");
      var result = await getUserNames(userList);
      setUserNames(result.data.body);
      setDiningRecords(records);
      setDataFetched(true);
    } catch (error) {
      console.error("Error fetching patient care records:", error);
    }
  };

  useEffect(() => {
    setDataFetched(false);
    loadData();
  }, [recordStatus, startDate, endDate]);

  // filter the data when provided filter options change
  useEffect(() => {
    const filterData = () => {
      let filteredRecords = diningRecords;

      if (selectedFacility !== "all") {
        filteredRecords = filteredRecords.filter(
          (record) => record.facility === selectedFacility
        );
      }

      if (selectedUnit !== "all") {
        filteredRecords = filteredRecords.filter(
          (record) => record.unit === selectedUnit
        );
      }

      if (selectedUser && selectedUser !== "All") {
        filteredRecords = filteredRecords.filter(
          (record) => record.auditedBy === selectedUser
        );
      }

      setFilteredDiningRecords(filteredRecords);
    };

    filterData();
  }, [diningRecords, selectedUnit, selectedFacility, selectedUser]);

  return (
    <div>
      {isDashboard ? (
        <>
          <DiningDataFilters
            facilities={facilities}
            setFacilities={setFacilities}
            selectedFacility={selectedFacility}
            setSelectedFacility={setSelectedFacility}
            selectedUnit={selectedUnit}
            setSelectedUnit={setSelectedUnit}
            units={units}
            setUnits={setUnits}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            recordStatus={recordStatus}
            setRecordStatus={setRecordStatus}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            resetFilters={resetFilters}
          />
          <DiningAuditSummary
            isDashboard={isDashboard}
            setIsDashboard={setIsDashboard}
            userNames={userNames}
            diningRecords={diningRecords}
            setDiningRecords={setDiningRecords}
            filteredDiningRecords={filteredDiningRecords}
            setFilteredDiningRecords={setFilteredDiningRecords}
            dataFetched={dataFetched}
          />

          {/* <div>
            <h2>Current Filters:</h2>
            <p>Facility: {selectedFacility}</p>
            <p>Unit: {selectedUnit}</p>
            <p>Observer: {selectedUser}</p>
            <p>Record Status: {recordStatus}</p>
            <p>Start Date: {startDate}</p>
            <p>End Date: {endDate}</p>
          </div> */}

          {/* <div style={{ marginTop: "100px" }}>
            {filteredDiningRecords ? (
              <pre>{JSON.stringify(filteredDiningRecords, null, 2)}</pre>
            ) : (
              <p>Fetching Data ...</p>
            )}
          </div> */}
        </>
      ) : (
        <>
          <Grid container alignItems="center">
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsDashboard(true);
                }}
              >
                Return to Dashboard
              </Button>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography
                variant="h2"
                style={{ textAlign: "center", margin: "20px 0" }}
              >
                Dining Form
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}></Grid>
          </Grid>
          <DiningForm
            isDashboard={isDashboard}
            setIsDashboard={setIsDashboard}
          />
        </>
      )}
    </div>
  );
};

export default DiningDashboard;
